module.exports = __webpack_public_path__ + "4874a6ca2548adcce687f2df8c80bdac.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/icon-search.svg
// module id = ./assets/images/header/icon-search.svg
// module chunks = 0